/*
 * @Author: LiuChuanQi
 * @Date: 2023-02-13 10:01:19
 * @LastEditTime: 2023-02-13 10:05:06
 * @LastEditors: LiuChuanQi
 * @Description: ase 加密key和偏移量
 * @FilePath: \speedtest-bigdata-v2\src\config\aes.js
 * 
 */
/**
 * key 秘钥（后端提供）由于对称解密使用的算法是 AES-128-CBC算法，数据采用 PKCS#7 填充 ， 因此这里的 key 需要为16位！
 * 偏移量（后端提供）
 */
export const ASEKEY = '5ECC5D62140EC099' //加密key
export const ASEIV = 'E63EA892A702EEAA'  //加密向量值偏移量
